import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import { industryNews, partners, podcasts } from "../../utils/Constant";

export default function RetailIndustryList() {
  const navigate = useNavigate();
  const handleIndustrydetail = (news) => {
    navigate(
      `/retail-source/leader-in-industry/industry-news-listing/industry-news-detail`,
      {
        state: { news }, // Pass full topic object
      }
    );
  };
  return (
    <div className="container-fluid ">
      {/* Sticky Header */}
      <div className=" d-flex mt-3">
        <div className="heading-main  mb-3">
          <h2>Industry News Listing</h2>
        </div>{" "}
      </div>
      {/* Scrollable Cards Container */}
      <div className="">
        <div
          className="row g-4"
          style={{ marginLeft: "10px", marginRight: "10px" }}
        >
          {industryNews.map((partner, index) => (
            <div key={index} className="col-md-4 col-sm-6 col-12">
              <div className="card d-flex flex-column h-100 shadow-sm">
                {/* Card Image */}
                <img
                  onClick={() => handleIndustrydetail(partner)}
                  style={{ cursor: "pointer" }}
                  src={partner.logo}
                  alt={partner.name}
                  className="card-img-top p-0"
                />

                {/* Card Content (Full Height) */}
                <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
                  <h5
                    onClick={() => handleIndustrydetail(partner)}
                    className="card-title"
                  >
                    {partner.name}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
